module.exports = __webpack_public_path__ + "img/2972e84.png";